import { Timestamp } from 'firebase/firestore';

/** Milliseconds for sorting; supports ISO strings (web) and Firestore Timestamp (e.g. mobile). */
export function notificationCreatedAtMs(value: unknown): number {
  if (value instanceof Timestamp) return value.toMillis();
  if (typeof value === 'string') {
    const ms = Date.parse(value);
    return Number.isNaN(ms) ? 0 : ms;
  }
  if (
    value &&
    typeof value === 'object' &&
    typeof (value as { toMillis?: () => number }).toMillis === 'function'
  ) {
    return (value as { toMillis: () => number }).toMillis();
  }
  if (value && typeof value === 'object' && typeof (value as { seconds?: number }).seconds === 'number') {
    const s = (value as { seconds: number; nanoseconds?: number }).seconds;
    const ns = (value as { nanoseconds?: number }).nanoseconds ?? 0;
    return s * 1000 + Math.floor(ns / 1e6);
  }
  return 0;
}
